var map = {
	"./EYES1.svg": 20205,
	"./EYES2.svg": 88227,
	"./EYES3.svg": 43935,
	"./EYES4.svg": 77019,
	"./EYES5.svg": 61978,
	"./EYES6.svg": 43730,
	"./EYES7.svg": 94488,
	"./EYES8.svg": 26169,
	"./EYES9.svg": 70910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56072;